module.exports = __webpack_public_path__ + "static/assets/9ce7bd322f865f40ab49b09ae54eb70f.svg";